// A trip share link keeps the whole itinerary inside the URL after the "#", which browsers never send to a server.
export interface SharedTrip { n: string; s: string; d: { t: string; o: string }[] }

const toB64Url = (bytes: Uint8Array) => btoa(Array.from(bytes, (b) => String.fromCharCode(b)).join("")).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
const fromB64Url = (s: string) => Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/")), (c) => c.charCodeAt(0));

export function encodeTrip(t: SharedTrip): string {
  return toB64Url(new TextEncoder().encode(JSON.stringify(t)));
}

/** Returns null for anything that isn't a well-formed shared trip. Text is length-capped so a hostile link can't flood the page. */
export function decodeTrip(code: string): SharedTrip | null {
  try {
    const j = JSON.parse(new TextDecoder().decode(fromB64Url(code))) as Partial<SharedTrip>;
    if (typeof j.n !== "string" || typeof j.s !== "string" || !Array.isArray(j.d) || j.d.length > 120) return null;
    const d = j.d.map((x) => ({ t: String((x as { t?: unknown })?.t ?? "").slice(0, 200), o: String((x as { o?: unknown })?.o ?? "").slice(0, 4000) }));
    return { n: j.n.slice(0, 200), s: /^\d{4}-\d{2}-\d{2}$/.test(j.s) ? j.s : "", d };
  } catch { return null; }
}
